module.exports = __webpack_public_path__ + "static/hey_bg-376cb6199704d60d829aa1b3506902d4.jpg";